module.exports = __webpack_public_path__ + "media/images/icons/outlined/close-circle-724b8f156483bc0cde49ca6020bdf847.svg";